import amountFormat from './amountFormat.js';

/** USD notional of one lot (backend still returns turnover in dollars). */
export const TURNOVER_LOT_USD = 100_000;

/**
 * Converts turnover in USD to lots.
 * Backend keeps returning dollar notional; UI shows lots = turnover / 100000.
 */
export function turnoverToLots(turnover: number | string | null | undefined): number {
    const value = Number(turnover);
    if (!Number.isFinite(value)) {
        return 0;
    }
    return value / TURNOVER_LOT_USD;
}

/**
 * Formats turnover (USD from API) as a human-readable lots string.
 */
export function formatTurnoverLots(
    turnover: number | string | null | undefined,
    fixed = 2,
): string {
    return amountFormat(turnoverToLots(turnover), fixed);
}
